import type { UserTypeEnum } from '@snowit/models';
import type { NavRoute } from '@snowit/wouter';

const filterMenu = (entry: NavRoute, type: UserTypeEnum, permissions: string[]): boolean => {
  if (!entry) return false;
  if (entry.hidden) return false;
  if (type === 'ADMIN') return true;
  if (type === 'USER' && (entry.type || 0) < 2) return false;
  if (entry.type === 2) return true;
  if (entry.type === 1 && entry.permissions?.length === 0) return true;
  if (!permissions.length || !entry.permissions?.length) return false;
  if (entry.logic === 'OR') {
    return entry.permissions.some((perm) => permissions.includes(perm));
  }
  return entry.permissions.every((perm) => permissions.includes(perm));
};

export default filterMenu;
